module.exports = __webpack_public_path__ + "static/media/Condizioni_generali_di_contratto_INMOTOVUNQUE_NUOVO_ul.3bea3050.pdf";